import React from "react";
import { Link } from "react-router-dom";
import { MessageSquare, Phone } from "lucide-react";

/** Shown wherever the cart or checkout used to be while card payments are paused. */
export default function PaymentsPausedNotice({ compact = false }) {
  return (
    <div
      className={`rounded-xl border ${compact ? "p-4" : "p-6"}`}
      style={{ borderColor: "rgba(198,162,74,0.28)", background: "rgba(198,162,74,0.06)" }}
      data-testid="payments-paused-notice"
    >
      <p className="text-sm font-semibold">Online card payments are being set up</p>
      <p className="mt-1.5 text-sm leading-relaxed text-[color:var(--nq-stone)]">
        Surplus stock is still for sale at cost price - we're just taking orders by phone and email
        for a few days. Send us the part you're after and we'll hold it, confirm fitment and take
        payment over the phone.
      </p>
      {!compact && (
        <div className="mt-4 flex flex-wrap gap-3">
          <Link to="/enquire" className="btn-gold" data-testid="payments-paused-enquire">
            <MessageSquare className="h-4 w-4" /> Enquire about a part
          </Link>
          <a href="tel:0747748859" className="btn-outline-nq" data-testid="payments-paused-call">
            <Phone className="h-4 w-4" /> (07) 4774 8859
          </a>
        </div>
      )}
    </div>
  );
}
